<template>
    <div>
        <v-navigation-drawer v-model="sideBar.show" app overflow :mini="sideBar.mini">
            <v-list-item class="ma-0 pa-0">
                <v-list-item-content class="pa-0">
                    <v-img src="@/assets/cover.png"></v-img>
                </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
    
    
            <v-list dense nav v-if="user && user.access">
                <v-list-item
                        v-for="access in Object.keys(accessSet)"
                        :key="access"
                        :to="accessSet[access].url"
                        v-if="user.access.indexOf(access) > -1"
                >
                    <v-list-item-icon>
                        <v-icon>{{accessSet[access].icon}}</v-icon>
                    </v-list-item-icon>
            
                    <v-list-item-content>
                        <v-list-item-title>{{accessSet[access].title}}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
            
            
        </v-navigation-drawer>
        <v-app-bar app color="primary" dark>
            <v-app-bar-nav-icon @click.stop="sideBar.show = !sideBar.show"></v-app-bar-nav-icon>
            <v-spacer></v-spacer>
                <v-toolbar-title> 
                <template v-if="user">
                    <router-link to="/">
                    <v-avatar>
                        <img :src="user.wrike.avatarUrl" :alt="`${user.wrike.firstName} ${user.wrike.lastName}`" :title="`${user.wrike.firstName} ${user.wrike.lastName}`">
                    </v-avatar>
                    </router-link>
                    <span class="ma-2">{{user.wrike.firstName}} {{user.wrike.lastName}}</span>
                </template>
                <template v-else>GuruWrike</template>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="clearCache" align="right">
                <v-icon>fas fa-trash</v-icon>
            </v-btn>
            <v-btn icon @click="showColors = true" align="right">
                <v-icon>fas fa-palette</v-icon>
            </v-btn>
            <v-btn icon @click="$router.push('/logout')" align="right">
                <v-icon>fas fa-sign-out-alt</v-icon>
            </v-btn>
        </v-app-bar>
        <v-main>
            <template v-if="user && user.access.indexOf('users') > -1 && users.length > 0">
                <router-link :to="'?user='+u.wrike.id" v-for="u in users" :key="u.wrike.id" v-if="u.wrike.id != user.wrike.id">
                    <v-avatar class="ma-3" avatar :tile="u.wrike.id == $route.query.user">
                        <img :src="u.wrike.avatarUrl" :alt="`${u.wrike.firstName} ${u.wrike.lastName}`" :title="`${u.wrike.firstName} ${u.wrike.lastName}`">
                    </v-avatar>
                </router-link>
            </template>
            <router-view :user="user"></router-view>
        </v-main>
        <v-dialog v-model="showColors" max-width="400px">
            <v-card>
                <v-card-text>
                    <v-container>
                        <a href="https://theme-generator.vuetifyjs.com" target="_blank">Generator <i class="fas fa-external-link-alt"></i></a>
                        <v-switch v-model="$vuetify.theme.dark" label="Dark theme"></v-switch>
                        <v-textarea auto-grow label="Theme colors" rows="9" v-model="colors" clearable autofocus></v-textarea>
                    </v-container>
                </v-card-text>
    
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary darken-1" text @click="showColors=false">Cancel</v-btn>
                    <v-btn color="primary darken-1" text @click="saveColors">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import api from '../api'
export default {
    name: 'DefaultLayout',
    data: () => ({
        sideBar:{
            show: false,
            mini: false
        },
        user: null,
        users: [],
        accessSet: {
            dashboard: {icon:'fas fa-tachometer-alt', title:"Dashboard", url:"/"},
            teams: {icon:'fas fa-users', title:"Teams", url:"/teams"},
            users: {icon:'fas fa-people-arrows', title:"Users", url:"/users"},
            manager: {icon:'fas fa-user-cog', title:"Manager", url:"/manager"},
            invoice: {icon:'fas fa-file-invoice-dollar', title:"Invoice", url:"/invoice"},
            simpleinvoice: {icon:'fas fa-file-invoice-dollar', title:"Simple Invoice", url:"/simpleinvoice"},
            login: {icon:'fas fa-sign-out-alt', title:"Logout", url:"/logout"},
        },
        showColors:false,
        colors: null
    }),
    methods:{
        clearCache(){
            localStorage.removeItem('folders');
            localStorage.removeItem('tasks');
        },
        saveColors(){
            if(this.colors && this.colors.trim().length > 0) {
                let colorProfile = { isDark: this.$vuetify.theme.dark, colors: {} }
                try{
                    colorProfile.colors = JSON.parse(this.colors)
                }catch(e){
                    this.colors = this.colors.trim()
                    if(this.colors.startsWith('{')) this.colors = this.colors.substring(1)
                    if(this.colors.endsWith('}')) this.colors = this.colors.substring(0, this.colors.length-1)
                    let properties = this.colors.trim().split(',')
                    properties.forEach(function(property) {
                        let tup = property.split(':')
                        colorProfile.colors[tup[0].trim()] = tup[1].trim()
                    })
                }
                
                localStorage.setItem('colorProfile', JSON.stringify(colorProfile))
                this.applyColors(colorProfile)
            }else{
                //restore
                localStorage.removeItem('colorProfile')
            }
            location.reload()
        },
        applyColors(colorProfile){
            this.$vuetify.theme.dark = colorProfile.isDark
            if(colorProfile.isDark) Object.assign(this.$vuetify.theme.themes.dark, colorProfile.colors)
            else Object.assign(this.$vuetify.theme.themes.light, colorProfile.colors)
        }
    },
    computed: {
        colorProfile(){
            let colorProfile = localStorage.getItem('colorProfile')
            if(!colorProfile){
                colorProfile = {
                    isDark: this.$vuetify.theme.dark,
                    colors: this.$vuetify.theme.dark ? this.$vuetify.theme.themes.dark : this.$vuetify.theme.themes.light
                }
            } else colorProfile = JSON.parse(colorProfile)
            return colorProfile
        }
    },
    created(){
        api.GET('/me').then(data => {
            this.user = data
            if(this.user.access.indexOf('users') > -1){
                api.GET('/users').then(data => this.users = data)
            }
        }).catch(err => setTimeout(window.location.reload.bind(window.location), 10000))
    },
    mounted(){
        this.colors = JSON.stringify(this.colorProfile.colors, null, 4)
        this.applyColors(this.colorProfile)
    }
}
</script>